import React from 'react'
// import { FieldContract } from '../Common/FieldsForForms'
import { LinearLoading } from 'common'
import { Box, Button, Checkbox, FormControl, FormControlLabel, Grid, IconButton, TextField, Typography } from '@mui/material'
import { CustomAutocomplete } from 'common'
import { FieldContract, InfoContract } from '../Common'
import { FileManagerInput } from 'common'
import { CheckCircle, Download, Plus, Trash2, UploadCloud, XCircle } from 'react-feather'
import { DepositTable } from './GSPRemovalSection/DepositTable'

const acceptConfiguration = {
    'application/pdf': []
}

export const IsuranceCancellation = ({ useFetchInit }) => {
    const { 
        //------------- Generales
        location,
        paramsURL,
        //------------- globalStates
        globalStates,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions,
        //------------- helpers
        Helpers,
        //------------- Formularios
        Forms
        
    } = useFetchInit

        // ------------------------------------------------ Formularios
        const { FormRequestGlobal } = Forms
        const { 
            formState, 
            onInputChange, 
            onInputChangeForCheckBox,
            onDropZoneAcceptedFilesChange, 
            onDropZoneRejectionsFilesChange, 
        } = FormRequestGlobal

        const { formOpeningMode} = globalStates

        //------------------------------------------------- Fech data

        //------------------------------------------------- Actions
        const {handleClickShowModal, onSubmitFormFiles} = Actions

    return (
        <>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Informacion sobre la gestion
            </Typography>
            <div className="border-bottom border-dark"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="fecha_fin_contrato">Fecha de finalizacion de contrato</label>
                        <TextField
                            id='fecha_fin_contrato'
                            name='fecha_fin_contrato'
                            value={ formState.fecha_fin_contrato } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='fecha_fin_contrato'
                            type='date'
                            variant='filled'
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="fecha_ren_seguro">Fecha de finalizacion de seguro</label>
                        <TextField
                            id='fecha_ren_seguro'
                            name='fecha_ren_seguro'
                            value={ formState.fecha_ren_seguro } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='fecha_ren_seguro'
                            type='date'
                            variant='filled'
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="seguro">Cuota de seguro (Q)</label>
                        <TextField
                            id='seguro'
                            name='seguro'
                            value={ formState.seguro } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Cuota Seguro'
                            type='text'
                            variant='filled'
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>

                 {/* Seccion de botones     */}
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="total_seguro">Total a cancelar (Q)</label>
                        <TextField
                            id='total_seguro'
                            name='total_seguro'
                            value={ formState.total_seguro } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='total_seguro'
                            type='text'
                            variant= 'filled'
                            InputProps={{
                                readOnly: true 
                            }}
                            
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2, }}>
                    <FormControl fullWidth>
                        <label htmlFor="butto_payment">Pago</label>
                        <Button
                            startIcon={<Plus/>}
                            variant='contained'
                            sx={{marginBottom: 4}} 
                            color='primary' 
                            onClick={()=>handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'EDITABLE')}
                            disabled={(formOpeningMode==='READONLY')? true : false}
                        >
                            Agregar Pago
                        </Button>
                    </FormControl>
                </Grid>
                
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                
                  <FormControl fullWidth>
                    <label htmlFor="tabla_depositos">Tabla de pagos</label>
                    <DepositTable useFetchInit={useFetchInit}/>
                  </FormControl>
                
                </Grid>
               
                {(!formState.check_seguro) && (
                    <>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2,}}>
                            <FormControl fullWidth>
                                <label htmlFor="tabla_depositos">* Carta de cancelacion de seguro</label>
                            </FormControl>
                        </Grid>


                        <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mb: 1, mt: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                                    <Button
                                        startIcon= {<UploadCloud/>}
                                        variant="contained"
                                        type="button"
                                        onClick={onSubmitFormFiles}
                                        className='btn-round'
                                        color='primary'
                                        sx={{ marginRight: 3, marginLeft: 1 }}
                                        disabled={ ((formOpeningMode === 'READONLY') || (formState.check_seguro)) ? true : false }
                                    >
                                        Subir archivos
                                    </Button>
                                    <Button
                                        startIcon={<XCircle/>}
                                        variant="contained"
                                        type="button"
                                        className='btn-round'
                                        color='error'
                                        // onClick={handleClickCleanUpFiles}
                                        sx={{ marginRight: 3, marginLeft: 1 }}
                                        disabled={ ((formOpeningMode === 'READONLY') || (formState.check_seguro)) ? true : false }
                                    >
                                        Limpiar
                                    </Button>
                        </Grid>

                        <Grid item xs={12} sm={12} md={9} lg={9} sx={{ mb: 1, mt: 2 }}>
                            {(formOpeningMode !== 'READONLY' ) && (
                                <FormControl fullWidth>
                                    <label htmlFor="attachmentt"> * Documentos</label>
                                        <FileManagerInput
                                            // datos (listados, individuales)
                                            acceptedFiles={formState.acceptedFiles}
                                            fileRejections={formState.fileRejections}
                                            NameId='attachmentt'
                                            typeFiles='PDF' 
                                            maxFiles={1}
                                            accept={acceptConfiguration}
                                
                                            // HandleClicks
                                
                                            // Funciones
                                            setAcceptedFiles={onDropZoneAcceptedFilesChange}
                                            setFileRejections={onDropZoneRejectionsFilesChange}
                                        />
                                </FormControl>
                            )}
                        </Grid>
                    </>
                )}
                {(formState.check_carta) && (
                    <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                      <Box 
                        display="flex" 
                        alignItems="center" 
                        justifyContent="space-between" 
                        bgcolor="green.100" 
                        p={2} 
                        borderRadius={2}
                        border="1px solid green"
                      >
                        <Box display="flex" alignItems="center">  
                          <CheckCircle color="green" size={32} />

                          <Typography variant="body1" color="green" ml={2}>
                            Confirmación de cancelación de seguro subida
                          </Typography>
                        </Box>

                        {(formOpeningMode === 'READONLY' ) && (

                            <Box display="flex" alignItems="center">
                              <IconButton
                                href={formState.document_path} 
                                target="_blank" 
                              >
                                <Download size={28} color='green' />  
                              </IconButton>

                            </Box> 
                        )}

                      </Box>
                    </Grid>
                )}
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                            name='check_seguro'
                            value={formState.check_seguro}
                            onChange={onInputChangeForCheckBox}
                            disabled = {(formOpeningMode === 'READONLY')}
                        />
                      }
                      label="Se renovará seguro"    
                    />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="gestion_descripcion">Descripcion</label>
                        <TextField
                            id='gestion_descripcion'
                            name='gestion_descripcion'
                            value={ formState.gestion_descripcion } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Descripcion'
                            type='text'
                            multiline
                            rows={5}
                            variant={(formOpeningMode==='READONLY')? 'filled': 'outlined'}
                            InputProps={{
                                readOnly: (formOpeningMode==='READONLY') ? true: false 
                            }}
                            
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </>
    )
}
